import UnknownDeviceTypeError from '../../exception/unknownDeviceTypeError';
import Garmin from './garmin';
import Suunto from './suunto';
import SuuntoV2 from './suuntoV2';
import Polar from './polar';
import Coros from './coros';
import Apple from '@/service/device/apple';

export default class DeviceFactory {
  constructor(logger, store, config, dao, eventBus) {
    this.logger = logger;

    this.params = [
      logger,
      store,
      config,
      dao,
      eventBus,
    ];
  }

  create(manufacturer) {
    this.logger.log('Building device for', manufacturer);
    switch (manufacturer.toLowerCase()) {
      case 'garmin':
        return new Garmin(...this.params);
      case 'suunto':
        return new Suunto(...this.params);
      case 'suuntov2':
        return new SuuntoV2(...this.params);
      case 'polar':
        return new Polar(...this.params);
      case 'coros':
        return new Coros(...this.params);
      case 'apple':
        return new Apple(...this.params);
      default:
        throw new UnknownDeviceTypeError();
    }
  }
}
